<div class="login-page">
    <div class="left-pane"></div>
    <div class="right-pane">
        <a routerLink="../auth/signin" class="logo">
            <img src="assets/images/BH_logo_1.png" alt="Blooming Health Logo" />
        </a>
        <div class="body">
            <ng-container *ngIf="!isAppInMaintenanceData; else appMaintenanceTemp">
                <bh-status [state]="generalMessages.NOT_FOUND_T" [message]="generalMessages.NOT_FOUND_ST"></bh-status>
            </ng-container>
            <ng-template #appMaintenanceTemp>
                <bh-status [state]="generalMessages.MAINTENANCE_T" [message]="generalMessages.MAINTENANCE_ST"></bh-status>
            </ng-template>
        </div>
        <!-- FOOTER LINKS BLOCK -->
        <span class="fixed-bottom-end secondary-text">
            <a href="https://gobloominghealth.com/terms-of-service/" target="_blank" class="mat-caption secondary-text"
                >Terms of Services</a
            >
            |
            <a href="https://gobloominghealth.com/privacy-policy/" target="_blank" class="mat-caption secondary-text">Privacy Policy</a>
        </span>
    </div>
</div>
